import React from "react";
import { Navbar } from "../header";
import { Footer } from "../footer";
import "./PortfolioPage.css";

export const CocktailPortfolio = () => {
  const galleryImages = [
    {
      id: 1,
      src: "/resources/images/cocktail/img1.jpg",
      category: "Couple Portraits",
      title: "Coffee & Cocktail"
    },
    {
      id: 2,
      src: "/resources/images/cocktail/img2.jpg",
      category: "Couple Portraits",
      title: "Elegant Evening"
    },
    {
      id: 3,
      src: "/resources/images/cocktail/img3.jpg",
      category: "Couple Portraits",
      title: "Romantic Moments"
    },
    {
      id: 4,
      src: "/resources/images/cocktail/img4.jpg",
      category: "Venue Events",
      title: "Status Weddings"
    },
    {
      id: 5,
      src: "/resources/images/cocktail/img5.jpg",
      category: "Venue Events",
      title: "Elegant Setup"
    },
    {
      id: 6,
      src: "/resources/images/cocktail/img6.jpg",
      category: "Cocktail Moments",
      title: "Evening Celebration"
    },
    {
      id: 7,
      src: "/resources/images/cocktail/img7.jpg",
      category: "Cocktail Moments",
      title: "Social Gathering"
    },
    {
      id: 8,
      src: "/resources/images/cocktail/img8.jpg",
      category: "Cocktail Moments",
      title: "Party Atmosphere"
    },
    {
      id: 9,
      src: "/resources/images/cocktail/img9.jpg",
      category: "Cocktail Moments",
      title: "Evening Elegance"
    },
    {
      id: 10,
      src: "/resources/images/cocktail/img10.jpg",
      category: "Cocktail Moments",
      title: "Social Soirée"
    },
    {
      id: 11,
      src: "/resources/images/cocktail/img11.jpg",
      category: "Cocktail Moments",
      title: "Party Vibes"
    },
    {
      id: 12,
      src: "/resources/images/cocktail/img12.jpg",
      category: "Cocktail Moments",
      title: "Evening Gathering"
    },
    {
      id: 13,
      src: "/resources/images/cocktail/img13.jpg",
      category: "Cocktail Moments",
      title: "Celebration Time"
    },
    {
      id: 14,
      src: "/resources/images/cocktail/img14.jpg",
      category: "Cocktail Moments",
      title: "Social Evening"
    },
    {
      id: 15,
      src: "/resources/images/cocktail/img15.jpg",
      category: "Cocktail Moments",
      title: "Party Night"
    },
    {
      id: 16,
      src: "/resources/images/cocktail/img16.jpg",
      category: "Cocktail Moments",
      title: "Evening Vibes"
    },
    {
      id: 17,
      src: "/resources/images/cocktail/img17.jpg",
      category: "Cocktail Moments",
      title: "Social Gathering"
    },
    {
      id: 18,
      src: "/resources/images/cocktail/img18.jpg",
      category: "Cocktail Moments",
      title: "Party Atmosphere"
    },
    {
      id: 19,
      src: "/resources/images/cocktail/img19.jpg",
      category: "Cocktail Moments",
      title: "Evening Celebration"
    },
    {
      id: 20,
      src: "/resources/images/cocktail/img20.jpg",
      category: "Cocktail Moments",
      title: "Social Soirée"
    },
    {
      id: 21,
      src: "/resources/images/cocktail/img21.jpg",
      category: "Cocktail Moments",
      title: "Party Night"
    },
    {
      id: 22,
      src: "/resources/images/cocktail/img22.jpg",
      category: "Cocktail Moments",
      title: "Evening Gathering"
    },
    {
      id: 23,
      src: "/resources/images/cocktail/img23.jpg",
      category: "Cocktail Moments",
      title: "Celebration Time"
    },
    {
      id: 24,
      src: "/resources/images/cocktail/img24.jpg",
      category: "Cocktail Moments",
      title: "Social Evening"
    },
    {
      id: 25,
      src: "/resources/images/cocktail/img25.jpg",
      category: "Cocktail Moments",
      title: "Party Vibes"
    },
    {
      id: 26,
      src: "/resources/images/cocktail/img26.jpg",
      category: "Cocktail Moments",
      title: "Evening Elegance"
    },
    {
      id: 27,
      src: "/resources/images/cocktail/img27.jpg",
      category: "Cocktail Moments",
      title: "Social Gathering"
    },
    {
      id: 28,
      src: "/resources/images/cocktail/img28.jpg",
      category: "Cocktail Moments",
      title: "Party Atmosphere"
    },
    {
      id: 29,
      src: "/resources/images/cocktail/img29.jpg",
      category: "Cocktail Moments",
      title: "Evening Celebration"
    },
    {
      id: 30,
      src: "/resources/images/cocktail/img30.jpg",
      category: "Cocktail Moments",
      title: "Social Soirée"
    },
    {
      id: 31,
      src: "/resources/images/cocktail/img31.jpg",
      category: "Cocktail Moments",
      title: "Party Night"
    },
    {
      id: 32,
      src: "/resources/images/cocktail/img32.jpg",
      category: "Cocktail Moments",
      title: "Evening Gathering"
    },
    {
      id: 33,
      src: "/resources/images/cocktail/img33.jpg",
      category: "Cocktail Moments",
      title: "Celebration Time"
    },
    {
      id: 34,
      src: "/resources/images/cocktail/img34.jpg",
      category: "Cocktail Moments",
      title: "Social Evening"
    },
    {
      id: 35,
      src: "/resources/images/cocktail/img35.jpg",
      category: "Cocktail Moments",
      title: "Party Vibes"
    },
    {
      id: 36,
      src: "/resources/images/cocktail/img36.jpg",
      category: "Cocktail Moments",
      title: "Evening Elegance"
    },
    {
      id: 37,
      src: "/resources/images/cocktail/img37.jpg",
      category: "Cocktail Moments",
      title: "Social Gathering"
    },
    {
      id: 38,
      src: "/resources/images/cocktail/img38.jpg",
      category: "Cocktail Moments",
      title: "Party Atmosphere"
    },
    {
      id: 39,
      src: "/resources/images/cocktail/img39.jpg",
      category: "Cocktail Moments",
      title: "Evening Celebration"
    },
    {
      id: 40,
      src: "/resources/images/cocktail/img40.jpg",
      category: "Cocktail Moments",
      title: "Social Soirée"
    },
    {
      id: 41,
      src: "/resources/images/cocktail/img41.jpg",
      category: "Cocktail Moments",
      title: "Party Night"
    },
    {
      id: 42,
      src: "/resources/images/cocktail/img42.jpg",
      category: "Cocktail Moments",
      title: "Evening Gathering"
    },
    {
      id: 43,
      src: "/resources/images/cocktail/img43.jpg",
      category: "Cocktail Moments",
      title: "Celebration Time"
    },
    {
      id: 44,
      src: "/resources/images/cocktail/img44.jpg",
      category: "Cocktail Moments",
      title: "Social Evening"
    },
    {
      id: 45,
      src: "/resources/images/cocktail/img45.jpg",
      category: "Cocktail Moments",
      title: "Party Vibes"
    },
    {
      id: 46,
      src: "/resources/images/cocktail/img46.jpg",
      category: "Couple Portraits",
      title: "Romantic Evening"
    },
    {
      id: 47,
      src: "/resources/images/cocktail/img47.jpg",
      category: "Couple Portraits",
      title: "Elegant Moments"
    },
    {
      id: 48,
      src: "/resources/images/cocktail/img48.jpg",
      category: "Couple Portraits",
      title: "Coffee Date"
    },
    {
      id: 49,
      src: "/resources/images/cocktail/img49.jpg",
      category: "Couple Portraits",
      title: "Evening Romance"
    },
    {
      id: 50,
      src: "/resources/images/cocktail/img50.jpg",
      category: "Couple Portraits",
      title: "Cocktail Date"
    },
    {
      id: 51,
      src: "/resources/images/cocktail/img51.jpg",
      category: "Couple Portraits",
      title: "Coffee & Cocktail"
    },
    {
      id: 52,
      src: "/resources/images/cocktail/img52.jpg",
      category: "Couple Portraits",
      title: "Evening Elegance"
    },
    {
      id: 53,
      src: "/resources/images/cocktail/img53.jpg",
      category: "Venue Events",
      title: "Status Weddings"
    },
    {
      id: 54,
      src: "/resources/images/cocktail/img54.jpg",
      category: "Venue Events",
      title: "Elegant Setup"
    },
    {
      id: 55,
      src: "/resources/images/cocktail/img55.jpg",
      category: "Venue Events",
      title: "Status Weddings"
    },
    {
      id: 56,
      src: "/resources/images/cocktail/img56.jpg",
      category: "Special Events",
      title: "Anniversary Celebration"
    }
  ];

  return (
    <div className="portfolio-detail-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="portfolio-detail-hero">
        <h1 className="detail-hero-title">Social Soirée Photography</h1>
        <div className="title-line"></div>
        <p className="detail-hero-subtitle">Capturing Elegant Evening Gatherings</p>
      </section>

      {/* Introduction */}
      <section className="portfolio-intro">
        <div className="intro-content">
          <h2>Social Soirées</h2>
          <p>Stories by Kalakaar brings elegance and sophistication to evening event photography. We specialize in capturing the refined atmosphere, exquisite details, and authentic moments that make these social gatherings memorable. From intimate gatherings to grand soirées, our photography preserves the essence of your sophisticated evening.</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="portfolio-gallery">
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div key={image.id} className="gallery-item">
              <div className="image-wrapper">
                <img src={image.src} alt={image.title} />
                <div className="image-overlay">
                  <div className="image-info">
                    <span className="image-category">{image.category}</span>
                    <h3 className="image-title">{image.title}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="portfolio-services">
        <div className="services-content">
          <h2>Our Evening Event Services</h2>
          <div className="services-grid">
            <div className="service-item">
              <h3>Ambiance Documentation</h3>
              <p>Capturing the sophisticated atmosphere</p>
            </div>
            <div className="service-item">
              <h3>Authentic Moments</h3>
              <p>Natural shots of guests enjoying the evening</p>
            </div>
            <div className="service-item">
              <h3>Artistic Details</h3>
              <p>Elegant shots of decor and refreshments</p>
            </div>
            <div className="service-item">
              <h3>Group Portraits</h3>
              <p>Sophisticated group compositions and social interactions</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="portfolio-cta">
        <div className="cta-content">
          <h2>Planning an Elegant Evening?</h2>
          <p>Let us capture the sophistication of your social gathering</p>
          <a href="/contactUs" className="cta-button">Get in Touch</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}; 